import { render, staticRenderFns } from "./FooterBottomTopHook.vue?vue&type=template&id=a0288786&"
import script from "./FooterBottomTopHook.js?vue&type=script&lang=js&"
export * from "./FooterBottomTopHook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports